import { Flex, Image, Text } from "@chakra-ui/react";
import { Select } from "chakra-react-select";

/**
 * Deprecated: use SelectCountry instead
 * @param {*} param0 
 * @returns 
 */
function CountrySelector({ data, selectedValue, handleCountryChange }) {
  const mapValue = (valueObj) => {
    return {
      label: <Flex gap={2} alignItems="center">
        <Text fontWeight="bold">{valueObj.name}</Text>
        <Image height="20px" src={valueObj.flag} />
      </Flex>,
      value: valueObj.name
    };
  };
  const renderOptions = () => {
    if (data && data.length > 0) {
      return data.map(country => {
        return mapValue(country);
      });
    }
    return [];
  };

  return (
    <Select
      id={"countrySelect"}
      value={mapValue(selectedValue)}
      onChange={(e) => {
        handleCountryChange(e.value);
      }}
      options={renderOptions()}
      chakraStyles={{
        singleValue: (provided) => ({
          ...provided,
          alignItems: "center"
        }),
        dropdownIndicator: (provided) => ({
          ...provided,
          bg: "transparent",
          px: 2,
          cursor: "inherit"
        }),
        indicatorSeparator: (provided) => ({
          ...provided,
          display: "none"
        }),
        container: (provided) => ({
          ...provided,
          fontSize: "md",
          fontWeight: "normal",
          textTransform: "initial",
          letterSpacing: "initial",
          width: "30%",
          backgroundColor: "white"
        }),
        control: (provided) => ({
          ...provided,
        //   borderRadius: "none"
        }),
        menuList: (provided) => ({
          ...provided,
        //   borderRadius: "none",
          minWidth: "100%"
        }),
        option: (provided) => ({
          ...provided,
          _hover: {
            backgroundColor: "gray.100"
          },
        })
      }}
    />
  );
}

export default CountrySelector;